module.exports = __webpack_public_path__ + "@/assets/img/1-2-logo-vertical-shadow.c9e8f8d0.png";